import type {
  PerformanceHistoryRange,
  PerformanceHistoryResponse,
  RetailAccountContent,
  UserRetailAccount,
} from '../types';

export type { PerformanceHistoryRange, PerformanceHistoryResponse };

export {
  assignComparisonColor,
  assignComparisonColorForAccount,
  assignComparisonColors,
  COMPARISON_PALETTE,
  LIVE_COMPARISON_COLOR,
  PAPER_COMPARISON_PALETTE,
} from './comparisonColors';

/** One portfolio row in a comparison view. */
export interface ComparisonAccount {
  accountId: string;
  /** Display label (nickname || content.accountName || fallback). */
  label: string;
  /** Stable color assigned by the parent (used in chart + chips). */
  color: string;
  account: UserRetailAccount;
  content?: RetailAccountContent;
  contentLoading?: boolean;
  contentError?: string | null;
  history?: PerformanceHistoryResponse;
  historyLoading?: boolean;
  historyError?: string | null;
}

/** Synthetic series id for the SPY benchmark line in charts. */
export const BENCHMARK_SERIES_ID = '__benchmark_SPY__';
export const BENCHMARK_LABEL = 'S&P 500 (SPY)';
export const BENCHMARK_COLOR = '#7B8798';
